export default __webpack_public_path__ + "static/media/hadaf.d80ed39b.jpg";